import { useState } from "react";
import { Popup, PopupHeader } from "react-weui-ts";
import { Handler } from "../common/handler";
import InlinePicker from "./InnerPicker";

interface ChordPopupProps {
  show: boolean;
  close: () => void;
  handler: Handler | null;
}

const ChordPopup = ({ show, close, handler }: ChordPopupProps) => {
  const [melody, setMelody] = useState("1");
  const [chord, setChord] = useState("1");

  return (
    <Popup show={show}>
      <PopupHeader
        left={"取消"}
        right={"确定"}
        leftOnClick={() => {
          close();
        }}
        rightOnClick={() => {
          handler?.structMatching(parseInt(melody), parseInt(chord))
          close();
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          background: "#fff",
        }}
      >
        <div style={{ flex: 1 }}>
          <InlinePicker
            options={["1", "2", "4"]}
            value={melody}
            setValue={setMelody}
          />
        </div>
        <div style={{ margin: 5 }}>V</div>
        <div style={{ flex: 1 }}>
          <InlinePicker
            options={["1"]}
            value={chord}
            setValue={setChord}
          />
        </div>
      </div>
    </Popup>
  );
};

export default ChordPopup;
